import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from 'mobx-react';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import BoxVdo from "components/BoxVdo/BoxVdo.jsx";
import SearchBox from "components/Search/Search.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Pagination from "components/Pagination/Pagination.jsx";
import Loader from 'components/Loader/LoaderView';


const styles = {
  ...dashboardStyle,
  ...extendedFormsStyle
};

class Dashboard extends React.Component {



  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    try {
      let { pagination } = this.props.search;
      let id = this.props.match.params.id;
      if (id) {
        let offset = (+id - 1) * pagination.limit
        this.props.search.changePaginationOffset(offset);
        await this.props.search.submitSearch('reload');
      } else {
        const data = await this.props.search.submitSearch();
        this.props.media.setMedias(data);
      }
      await this.props.category.loadCategories();
    } catch (error) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: "block", marginTop: "-100px" }}
            title={`Error !`}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {`${error.message}`}
          </SweetAlert>
        )
      });
    }
  }

  async onChangePage(page) {
    let { pagination } = this.props.search;
    let offset = 0;
    switch (page) {
      case '<<':
        offset = 0;
        break;
      case 'PREV':
        offset = (pagination.page - 2) * pagination.limit
        break;
      case '>>':
        offset = (pagination.total_pages - 1) * pagination.limit;
        break;
      case 'NEXT':
        offset = pagination.page * pagination.limit;
        break;
      default:
        offset = (+page - 1) * pagination.limit;
        break;
    }
    this.props.search.changePaginationOffset(offset);
    const response = await this.props.search.submitSearch('reload');
    if (response.pagination.page) {
      this.props.history.push(`/admin/dashboard/page/${response.pagination.page}`)
    }
  }

  render() {
    let { pagination, mediaList, loading: loadingSearch } = this.props.search;
    let { loading: loadingMedia } = this.props.media;
    let pages = [];
    if (pagination.page !== 1) {
      pages.push({ text: '<<' })
      pages.push({ text: 'PREV' })
    }
    for (let i = 1; i <= pagination.total_pages; i++) {
      if (i >= pagination.page - 10 && i <= pagination.page + 10) {
        if (pagination.page === i) {
          pages.push({ active: true, text: i })
        } else {
          pages.push({ text: i })
        }
      }
    }
    if (pagination.page !== pagination.total_pages) {
      pages.push({ text: 'NEXT' })
      pages.push({ text: '>>' })
    }

    return (
      <Fragment>
        <Loader
          loading={loadingSearch || loadingMedia}
        />
        <SearchBox title={'VDO List'} history={this.props.history} />
        <br />
        <br />
        <GridContainer>
          {mediaList.map(media => {
            return <BoxVdo key={media.id} data={media} history={this.props.history} />
          })}
        </GridContainer>
        <div style={{ float: 'right' }}>
          {(pages.length > 0) && <Pagination pages={pages} history={this.props.history} _onChangePage={this.onChangePage.bind(this)} />}
        </div>
      </Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export const page = inject('media', 'search', 'category')(observer(Dashboard));
export default withStyles(styles, { withTheme: true })(page);
